import { useEffect } from "react";
import Page from "~/components/Page";
import { VStack } from "@chakra-ui/react";
import { logout } from "~/actions/AuthActions";
import { useRouter } from "next/router";
import { Label01, Paragraph02 } from "~/components/Texts";
import Spinner from "~/components/animations/Spinner";
import { useUser } from "~/context/userContext";

export default function Logout() {
  const router = useRouter();
  const { user } = useUser();

  useEffect(() => {
    if (user) doLogout();
    else router.replace("/auth/login");
  }, []);

  async function doLogout() {
    return logout().then(() => router.replace("/auth/login"));
  }

  return (
    <Page title="Cerrando sesión... | Shop Story">
      <VStack w="100%" h="100%" justify="center" spacing="8">
        <Spinner />
        <Label01>Cerrando sesión...</Label01>
        <Paragraph02>Por favor, no cierres esta ventana.</Paragraph02>
      </VStack>
    </Page>
  );
}
